import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  uploadFile(file: File) {
    const formData = new FormData();

    formData.append('file', file);

    return this.http.post(
      `${this.baseUrl}/v1/media/upload`,
      formData
    );
  }

}